import React from 'react';

import { Box } from '@chakra-ui/react';

import { MeshMavenDisabledThumbsUp } from 'assets/assetsV1/iconComponents/MeshMavenDisabledThumbsUp';
import { MeshMavenWithThumbsUp } from 'assets/assetsV1/iconComponents/MeshMavenWithThumbsUp';

import { Button } from 'uiToolkitV1/Button';

import './GradientButton.css';

export const ICON_SIZES = { NORMAL: 'normal', SMALL: 'small' };

const GradientButton = React.forwardRef(
  (
    {
      text = 'Help me Write',
      isDisabled = false,
      iconSize = ICON_SIZES.NORMAL,
      onClick = () => {},
      buttonProps = {},
      icon = null,
      ...rest
    },
    ref
  ) => (
    <Box className="gradient-button-container " p="1px" ref={ref} {...rest}>
      <Button
        StartIcon={icon || (isDisabled ? MeshMavenDisabledThumbsUp : MeshMavenWithThumbsUp)}
        startIconProps={{ padding: '4px', opacity: '1' }}
        className={`ai-button ${isDisabled ? 'disabled' : ''}`}
        variant="tertiary"
        isDisabled={isDisabled}
        padding={iconSize === ICON_SIZES.NORMAL ? '8px 16px 8px 8px' : '4px'}
        height={iconSize === ICON_SIZES.NORMAL ? '32x !important' : '32px !important'}
        iconSize={iconSize === ICON_SIZES.NORMAL ? '24px' : '20px'}
        data-text={text}
        onClick={onClick}
        {...buttonProps}
      />
    </Box>
  )
);

export default GradientButton;
